var _rect, _rect2, _rect3, _rect4, _rect5, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroPattern(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 349,
    viewBox: "0 0 259 349",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 239.509,
    y: 181.625,
    width: 1,
    height: 160,
    transform: "rotate(103.97 239.509 181.625)",
    fill: "#E1E8EA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 258.447,
    y: 151.964,
    width: 1,
    height: 240,
    transform: "rotate(126.491 258.447 151.964)",
    fill: "#E1E8EA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 240.002,
    y: 218.789,
    width: 1,
    height: 240,
    transform: "rotate(90.1883 240.002 218.789)",
    fill: "#E1E8EA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 240.041,
    y: 258,
    width: 1,
    height: 180,
    transform: "rotate(79.5956 240.041 258)",
    fill: "#E1E8EA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 250.039,
    y: 290,
    width: 1,
    height: 100,
    transform: "rotate(61.6892 250.039 290)",
    fill: "#E1E8EA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 162,
    r: 8.5,
    fill: "#FED0AB",
    stroke: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 218,
    r: 8.5,
    fill: "white",
    stroke: "#E1E8EA"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 345,
    r: 3.5,
    fill: "white",
    stroke: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 236,
    cy: 299,
    r: 8.5,
    fill: "#FED0AB",
    stroke: "black"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 197,
    cy: 243,
    r: 8.5,
    fill: "#E1E8EA",
    stroke: "black"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 41,
    r: 8.5,
    fill: "#E1E8EA",
    stroke: "black"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 195,
    r: 3.5,
    fill: "#E1E8EA",
    stroke: "black"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.0902,
    cy: 9.09004,
    r: 8.5,
    transform: "rotate(0.576106 65.0902 9.09004)",
    fill: "#C8BEFF",
    stroke: "black"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 213,
    cy: 149,
    r: 3.5,
    fill: "#C8BEFF",
    stroke: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroPattern);
export default __webpack_public_path__ + "static/media/hero-pattern.f21fab964dfe4ff56a9b1d9eabe7cae1.svg";
export { ForwardRef as ReactComponent };